import { createFileRoute } from '@tanstack/react-router';
import { DesktopGpusPage } from '../screens/admin/DesktopGpusPage';

export const Route = createFileRoute('/admin/desktop-gpus')({
  component: DesktopGpusPage,
});
